// Shopify renders suggestions and prices; this controller only manages the panel.
(() => {
  const recentKey = 'fivepoint:recent-searches:v1';
  function connect(root = document) {
    root.querySelectorAll('[data-fp-search]:not([data-search-connected])').forEach(form => {
      form.dataset.searchConnected = 'true';
      const header = form.closest('[data-fp-header]');
      const input = form.querySelector('[name="q"]');
      const panel = document.getElementById(input.getAttribute('aria-controls'));
      const content = panel.querySelector('[data-fp-search-content]');
      const status = panel.querySelector('[data-fp-search-status]');
      const initial = content.innerHTML;
      const cache = new Map();
      let timer, request, revision = 0, restoringFocus = false;
      const searchURL = query => {
        const url = new URL(form.action);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        return url;
      };
      const readRecent = () => {
        const entries = JSON.parse(localStorage.getItem(recentKey) || '[]');
        if (!Array.isArray(entries) || entries.some(term => typeof term !== 'string')) throw new Error('Invalid recent searches');
        return entries.filter(term => term.trim() && term.length <= 120).slice(0, 5);
      };
      const renderRecent = () => {
        const group = panel.querySelector('[data-fp-recent-searches]');
        const list = group.querySelector('[data-fp-recent-list]');
        list.replaceChildren();
        try {
          const terms = readRecent();
          group.hidden = !terms.length;
          terms.forEach(term => {
            const link = document.createElement('a');
            link.href = searchURL(term); link.textContent = term;
            list.append(link);
          });
        } catch (error) {
          group.hidden = false;
          const message = document.createElement('p');
          message.textContent = 'Recent searches are unavailable in this browser.';
          list.append(message);
        }
      };
      const open = () => {
        if (restoringFocus) return;
        panel.hidden = false;
        header.classList.add('fp-search-open');
        input.setAttribute('aria-expanded', 'true');
        header.querySelectorAll('.fp-mega-trigger[aria-expanded="true"],.fp-desktop-menu[aria-expanded="true"]').forEach(trigger => {
          document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        });
        renderRecent();
      };
      const close = (focus = false) => {
        panel.hidden = true;
        header.classList.remove('fp-search-open');
        input.setAttribute('aria-expanded', 'false');
        if (focus) {
          restoringFocus = true; input.focus(); restoringFocus = false;
        }
      };
      const render = html => {
        content.innerHTML = html;
        content.removeAttribute('aria-busy');
        const count = content.querySelector('[data-product-count]').dataset.productCount;
        status.textContent = `${count} fabric suggestions.`;
      };
      const suggest = async () => {
        const query = input.value.trim();
        const current = ++revision;
        request?.abort();
        if (!query) { render(initial); return; }
        if (cache.has(query)) { render(cache.get(query)); return; }
        request = new AbortController();
        content.setAttribute('aria-busy', 'true');
        status.textContent = 'Searching fabrics…';
        try {
          const url = new URL(form.dataset.suggestUrl, location.origin);
          url.search = new URLSearchParams({
            q: query, 'resources[type]': 'product,collection', 'resources[limit]': '8',
            'resources[limit_scope]': 'each', 'resources[options][fields]': 'title,product_type,variants.title,variants.sku',
            section_id: 'fivepoint-predictive-search'
          });
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error(`Search returned ${response.status}`);
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = document.querySelector('[data-fp-search-results]');
          if (!results) throw new Error('Search response is missing suggestions');
          if (current !== revision) return;
          if (cache.size >= 6) cache.delete(cache.keys().next().value);
          cache.set(query, results.outerHTML);
          render(results.outerHTML);
        } catch (error) {
          if (error.name === 'AbortError' || current !== revision) return;
          content.removeAttribute('aria-busy');
          content.replaceChildren();
          const message = document.createElement('p');
          message.className = 'fp-search-error'; message.setAttribute('role', 'alert');
          message.textContent = 'Search suggestions could not load. ';
          const retry = document.createElement('button');
          retry.type = 'button'; retry.textContent = 'Try again'; retry.addEventListener('click', suggest);
          const link = document.createElement('a');
          link.href = searchURL(query); link.textContent = 'View full search results →';
          message.append(retry, link); content.append(message);
          status.textContent = 'Search suggestions could not load.';
          console.error('FivePoint predictive search:', error);
        }
      };
      input.addEventListener('focus', () => { open(); if (!restoringFocus && input.value.trim()) suggest(); });
      input.addEventListener('click', open);
      input.addEventListener('input', () => {
        open(); clearTimeout(timer); ++revision; request?.abort();
        timer = setTimeout(suggest, 200);
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); open(); panel.querySelector('a')?.focus();
        }
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
      });
      panel.querySelector('[data-fp-search-close]').addEventListener('click', () => close(true));
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target) && !panel.contains(event.target)) close(); });
      document.addEventListener('focusin', event => { if (!form.contains(event.target) && !panel.contains(event.target)) close(); });
      form.addEventListener('submit', () => {
        const query = input.value.trim();
        if (!query) return;
        window.FivePointEvents?.emit('fp_search_submit', {query_length: query.length}, {source_surface:'header',component_id:'header-search'});
        try { localStorage.setItem(recentKey, JSON.stringify([query, ...readRecent().filter(term => term !== query)].slice(0, 5))); }
        catch (error) { console.error('FivePoint recent searches could not be saved:', error); }
      });
      header.querySelectorAll('.fp-country').forEach(country => {
        document.addEventListener('pointerdown', event => { if (!country.contains(event.target)) country.open = false; });
        country.addEventListener('keydown', event => { if (event.key === 'Escape') { country.open = false; country.querySelector('summary').focus(); } });
      });
    });
  }
  document.addEventListener('shopify:section:load', event => connect(event.target));
  connect();
})();
